import { OnboardingService } from '@/services/onboarding.service';

export default {
  namespaced: true,
  state: {
    isImageUploadProcessing: false,
    onboardingPatient: null,
    redesignFlows: ['C', 'D1','D2', 'E1', 'F1', 'F2', 'F3v1', 'F3v2', 'G', 'H', 'J', '1225-onboarding-core-v1', 'K'],
  },
  mutations: {
    SET_IS_IMAGE_UPLOAD_PROCESSING(state, payload) {
      state.isImageUploadProcessing = payload;
    },
    SET_STATE(state, payload) {
      state[payload.state] = payload.value;
    },
    SET_FLOW_VARIANT(state, flowVariant) {
      if (state.onboardingPatient) {
        state.onboardingPatient.flow_variant = flowVariant;
      }
    },
  },
  actions: {
    async getPatientOnboarding ({ commit }) {
      const { data } = await OnboardingService.getPatientOnboarding();

      commit('SET_STATE', {
        state: 'onboardingPatient',
        value: data,
      });

      return data;
    },
    async checkCoupon (ctx, couponid) {
      const { data } = await OnboardingService.checkCoupon(couponid);
      return data
    },
    async applyCoupon (ctx, couponid) {
      await OnboardingService.applyCoupon({
        couponid
      });
    },
    async getProductReveal() {
      const { data } = await OnboardingService.getProductReveal();
      return data
    }
  },
};
